import { createContract } from './create-contract/createContract.ts'

export default {
  createContract
}
